import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'

import 'tailwindcss/base.css'
import 'tailwindcss/components.css'
import 'tailwindcss/utilities.css'
import './src/css/index.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import '@fontsource/playfair-display/800.css' // Weight 800.
import '@fontsource/playfair-display/800-italic.css' // Loads the italic variant.

// The FontAwesome CSS is imported explicitly above (replacing
// gatsby-plugin-fontawesome-css), so stop the library from injecting it again.
config.autoAddCss = false
